import MasterCrudPage from "../../components/MasterCrudPage";
import { addressTypeApi } from "../../api/masterApi";

export default function AddressType() {
  return (
    <MasterCrudPage
      title="Address Type Master"
      description="Define address types (Home, Office)."
      idKey="address_type_id"
      api={addressTypeApi}
      listLabel="address types"
      useJson
      fields={[
        {
          name: "address_type_name",
          label: "Address Type",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. Home, Office",
        },
      ]}
      columns={[
        { key: "address_type_id", label: "Address Type" },
        { key: "address_type_name", label: "Address Type" },
      ]}
    />
  );
}
